import { DateAdapter } from "@myphx-engineering/date-utils/client";

//#region src/utils/get-current-time-window-status.ts
/**
* Determines the status of the current time relative to a given time window
* Uses Temporal API for accurate timezone-aware comparisons
*
* @param start - The start time in ISO-8601 string format
* @param end - The end time in ISO-8601 string format
* @returns Returns 'within', 'past', 'future', or 'invalid' based on the current time and the window
*/
const getCurrentTimeWindowStatus = (start, end) => {
	if (!start || !end) return "invalid";
	try {
		const startTime = DateAdapter.fromISO(start);
		const endTime = DateAdapter.fromISO(end);
		const currentTime = DateAdapter.now();
		if (startTime.epochMilliseconds > endTime.epochMilliseconds) return "invalid";
		if (currentTime.epochMilliseconds < startTime.epochMilliseconds) return "future";
		if (currentTime.epochMilliseconds > endTime.epochMilliseconds) return "past";
		return "within";
	} catch {
		return "invalid";
	}
};

//#endregion
export { getCurrentTimeWindowStatus };